import { call, put, all, takeEvery } from 'redux-saga/effects'
import * as actions from './actions'
import * as types from '../types'
import api from '../../../services/api'

function* getAllMaterialsReduced ({payload}) {
    try {
        const response = yield call (api.get, '/materialReduced')
        yield put (actions.getAllMaterialsReducedSuccess(response))
    } catch (e) {
        console.log(e)
    }
}

function* getMaterialBrands () {
    try {
        const response = yield call (api.get, '/materialBrands')
        yield put (actions.getMaterialBrandsSuccess(response.data.brands))
    } catch (e) {
        console.log(e)
    }
}

function* getMaterialsByBrands ({payload}) {
    try {
        // axios serializa o array como brands[]=Ceusa&brands[]=Eliane
        const response = yield call (api.get, '/materialReduced', {
            params: { brands: payload },
        })
        yield put (actions.getMaterialsByBrandsSuccess(payload, response.data.materials))
    } catch (e) {
        console.log(e)
        yield put (actions.getMaterialsByBrandsSuccess(payload, []))
    }
}

export default all([
    takeEvery(types.GET_ALL_MATERIALS_REDUCED, getAllMaterialsReduced),
    takeEvery(types.GET_MATERIAL_BRANDS, getMaterialBrands),
    takeEvery(types.GET_MATERIALS_BY_BRANDS, getMaterialsByBrands)
])
